import { useEffect, useState } from 'react';

export const useDeviceType = () => {
  const [isTablet, setIsTablet] = useState(false);
  const [isIpad, setIsIpad] = useState(false);
  const [isAndroidTablet, setIsAndroidTablet] = useState(false);
  const [isWindowsTablet, setIsWindowsTablet] = useState(false);

  useEffect(() => {
    const ua = navigator.userAgent.toLowerCase();

    const _isIpad = /ipad/.test(ua);
    const _isAndroidTablet = /android/.test(ua) && !/mobile/.test(ua);
    const _isWindowsTablet =
      /windows/.test(ua) && /touch/.test(ua) && !/phone/.test(ua);

    setIsIpad(_isIpad);
    setIsAndroidTablet(_isAndroidTablet);
    setIsWindowsTablet(_isWindowsTablet);
    setIsTablet(_isIpad || _isAndroidTablet || _isWindowsTablet);
  }, [setIsIpad, setIsAndroidTablet, setIsWindowsTablet, setIsTablet]);

  return { isTablet, isIpad, isAndroidTablet, isWindowsTablet };
};

export const useBrowser = () => {
  const [isSafari, setIsSafari] = useState(false);
  const [isChrome, setIsChrome] = useState(false);
  const [isFirefox, setIsFirefox] = useState(false);
  const [isSamsungBrowser, setIsSamsungBrowser] = useState(false);

  useEffect(() => {
    const ua = navigator.userAgent.toLowerCase();
    const _isChrome =
      /crios/.test(ua) || (/chrome/.test(ua) && /android/.test(ua));
    const _isFirefox = /fxios/.test(ua);
    const _isSamsungBrowser = /samsungbrowser/.test(ua);
    const _isSafari = /safari/.test(ua) && !_isChrome && !_isFirefox;
    setIsSafari(_isSafari);
    setIsChrome(_isChrome);
    setIsFirefox(_isFirefox);
    setIsSamsungBrowser(_isSamsungBrowser);
  }, []);

  return { isSafari, isChrome, isFirefox, isSamsungBrowser };
};
